import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { Contracts } from "./Contracts";
import { PropertyId, SpeechConfigImpl } from "./Exports";
/**
 * Class that defines base configurations for dialog service connector
 * @class DialogServiceConfig
 */

export var DialogServiceConfig =
/**
 * Creates an instance of DialogService config.
 * @constructor
 */
function DialogServiceConfig() {
  _classCallCheck(this, DialogServiceConfig);
};
/**
 * Dialog Service configuration.
 * @class DialogServiceConfigImpl
 */
// tslint:disable-next-line:max-classes-per-file

export var DialogServiceConfigImpl = /*#__PURE__*/function (_DialogServiceConfig) {
  _inherits(DialogServiceConfigImpl, _DialogServiceConfig);

  /**
   * Creates an instance of dialogService config.
   */
  function DialogServiceConfigImpl() {
    var _this;

    _classCallCheck(this, DialogServiceConfigImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DialogServiceConfigImpl).call(this));
    _this.privSpeechConfig = new SpeechConfigImpl();
    return _this;
  }
  /**
   * Provides access to custom properties.
   * @member DialogServiceConfigImpl.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The properties.
   */


  _createClass(DialogServiceConfigImpl, [{
    key: "setProperty",

    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to set.
     * @param {string} value - The value.
     */
    value: function setProperty(name, value) {
      this.privSpeechConfig.setProperty(name, value);
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to get.
     * @param {string} def - The default value to return in case the property is not known.
     * @returns {string} The current value, or provided default, of the given property.
     */

  }, {
    key: "getProperty",
    value: function getProperty(name, def) {
      return this.privSpeechConfig.getProperty(name);
    }
    /**
     * Sets the proxy configuration.
     * Only relevant in Node.js environments.
     * Added in version 1.4.0.
     * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
     * @param proxyPort The port number of the proxy server.
     * @param proxyUserName The user name of the proxy server.
     * @param proxyPassword The password of the proxy server.
     */

  }, {
    key: "setProxy",
    value: function setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
      this.setProperty(PropertyId.SpeechServiceConnection_ProxyHostName, proxyHostName);
      this.setProperty(PropertyId.SpeechServiceConnection_ProxyPort, "".concat(proxyPort));

      if (proxyUserName) {
        this.setProperty(PropertyId.SpeechServiceConnection_ProxyUserName, proxyUserName);
      }

      if (proxyPassword) {
        this.setProperty(PropertyId.SpeechServiceConnection_ProxyPassword, proxyPassword);
      }
    }
  }, {
    key: "setServiceProperty",
    value: function setServiceProperty(name, value, channel) {
      this.privSpeechConfig.setServiceProperty(name, value, channel);
    }
    /**
     * Dispose of associated resources.
     * @member DialogServiceConfigImpl.prototype.close
     * @function
     * @public
     */

  }, {
    key: "close",
    value: function close() {
      return;
    }
  }, {
    key: "properties",
    get: function get() {
      return this.privSpeechConfig.properties;
    }
    /**
     * Gets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     */

  }, {
    key: "speechRecognitionLanguage",
    get: function get() {
      return this.privSpeechConfig.speechRecognitionLanguage;
    }
    /**
     * Sets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The language to set.
     */
    ,
    set: function set(value) {
      Contracts.throwIfNullOrWhitespace(value, "value");
      this.privSpeechConfig.speechRecognitionLanguage = value;
    }
  }]);

  return DialogServiceConfigImpl;
}(DialogServiceConfig);